"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleBreakpoints = handleBreakpoints;
/**
 * Construct CSS media-query properties for propValue with the theme's breakpoint
 */
function handleBreakpoints(theme, propValue, styleFromPropValue) {
  if (Array.isArray(propValue)) {
    const themeBreakpoints = theme.busbud.breakpoints;
    const cssPropeties = {};
    return propValue.reduce((acc, item, index) => {
      acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
      return acc;
    }, cssPropeties);
  }
  if (typeof propValue === 'object') {
    const themeBreakpoints = theme.busbud.breakpoints;
    const cssPropeties = {};
    const propValueKeys = Object.keys(propValue);

    // Make sure to sort keys adequately based on numerical value
    propValueKeys.sort((a, b) => {
      const aAsNumber = parseInt(a) || themeBreakpoints.values[a];
      const bAsNumber = parseInt(b) || themeBreakpoints.values[b];
      return aAsNumber > bAsNumber ? 1 : -1;
    });
    return propValueKeys.reduce((acc, breakpoint) => {
      acc[themeBreakpoints.up(parseInt(breakpoint) || breakpoint)] = styleFromPropValue(propValue[breakpoint]);
      return acc;
    }, cssPropeties);
  }
  const output = styleFromPropValue(propValue);
  return output;
}